module.exports = __webpack_public_path__ + "static/img/081015042q68.9f3ac554.jpg";